<script>
  import { onMount } from "svelte";
  import config from "./stores/config";
  import Layout from "./Layout/Layout.svelte";
  import Hero from "./components/Hero.svelte";
  import Work from "./components/Work.svelte";
  import Skills from "./components/Skills.svelte";
  import Contact from "./components/Contact.svelte";
  import Loading from "./components/Loading.svelte";
  import Header from "./Layout/Header.svelte";

  // let visible = true;
  let visible = false;
  onMount(() => {
    setTimeout(() => {
      visible = true;
    }, $config.waitTime);
  });
</script>

<Layout>
  {#if visible}
    <Header />
    <Hero />
    <Work />
    <Skills />
    <Contact />
  {:else}
    <Loading />
  {/if}
</Layout>

<style>
</style>
